import React from 'react';
import { useLinkedEntityCards } from '../../../shared/components/linked-entities/LinkedEntityCardHost';
import EntityLinkButton from '../../../shared/components/linked-entities/EntityLinkButton';

export function formatEventOrigin(event) {
  const origin = event?.linkedEntity;
  if (origin) return [event.sourceLabel, origin.label || origin.actionLabel || 'Apri origine'].filter(Boolean).join(' · ');
  return event?.sourceLabel || (event?.isReadOnly ? 'Sistema' : 'Calendario');
}

export default function EventOriginLink({ event, onOpenEvent }) {
  const { openEntityCard } = useLinkedEntityCards();
  const origin = event?.linkedEntity;
  const label = formatEventOrigin(event);
  if (!origin) return onOpenEvent
    ? <EntityLinkButton onClick={() => onOpenEvent(event)} aria-label={`Apri origine: ${event.title}`}>{label}</EntityLinkButton>
    : <span>{label}</span>;

  const openOrigin = () => openEntityCard({
    entityType: origin.type?.replaceAll('-', '_'), entityId: origin.id,
  });
  if (!origin.route) return <EntityLinkButton onClick={openOrigin}>{label}</EntityLinkButton>;
  return <a href={origin.route} className="entity-link-button" aria-label={origin.actionLabel || `Apri origine: ${label}`}
    onClick={(click) => {
      click.stopPropagation();
      if (!click.ctrlKey && !click.metaKey && !click.shiftKey && !click.altKey && openOrigin()) click.preventDefault();
    }}>{label}</a>;
}
